module.exports = __webpack_public_path__ + "static/media/aero_credit_icon.285e6c14.svg";